<style lang="scss" scoped>
.block {
  width: 1200px;
  background: #fff;
  justify-content: space-between;
  padding: 28px 0;
  margin-bottom: 24px;
  min-width: 1200px;
  .title {
    display: flex;
    .comma {
      width: 8px;
      height: 30px;
      background: #1890ff;
      margin-right: 16px;
    }
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 30px;
  }
  .desc {
    margin: 12px 57px;
    background: #fff7e6;
    border-radius: 4px;
    border: 1px solid #ffd591;
    padding: 8px 10px;
    .icon {
    }
  }
  .image {
    margin: 24px auto;
    width: 1008px;
  }
}
</style>
<template>
  <div class="block">
    <div class="title">
      <div class="comma" />
      <div>
        {{ title }}
      </div>
    </div>
    <div
      v-if="desc"
      class="desc"
    >
      <div class="icon" />
      {{ desc }}
    </div>
    <slot name="form" />

    <div class="image" v-if='images'>
      <img
        style="width: 100%"
        :src="images"
        alt=""
      >
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'FormBlock',
  props: {
    title: {
      type: String,
      default: ``
    },
    desc: {
      type: String,
      default: ''
    },
    callFun: {
      type: Function,
      default: (res) => {
        console.log('callFun', res)
        return res
      }
    },
    images: {
      type: String,
      default: 'https://b-uat.jusstickets.com//static/img/logo2.e0ee6fe.jpg'
    }
  },
  data () {
    return {}
  },
  watch: {},
  mounted () {},
  methods: {}
}
</script>
